document.addEventListener('DOMContentLoaded', function () {

    const container = document.querySelector('.wp-block-tribe-blocks-product-resources');
    if (!container) return;

    const form = container.querySelector('form');
    if (!form) return;

    const checkboxes = form.querySelectorAll('input[type="checkbox"]');

    checkboxes.forEach(function (cb) {
        cb.addEventListener('change', function () {

            // Reset pagination on filter change
            const pageInput = form.querySelector('input[name="resources_page"]');
            if (pageInput) {
                pageInput.value = 1;
            }

            form.submit();
        });
    });

});
